import { useContext, useEffect, useState } from "react"
import { VisitantesContext } from "../../../../Providers/VisitantesContext/VisitantesContext"
import { CircularProgress, Grid, Typography } from "@mui/material"
import AddIcon from '@mui/icons-material/Add'
import CardAutorizados from "./CardAutorizados"
import OneButton from "../../../../Components/OneButton/OneButton"
import ModalAutorizados from "./ModalAutorizados"

const Autorizados = () => {
    const { visitanteInfo, selecionarAutorizacao, autorizados, convites, novoVisitante, setSolicitarSalvarVisitante, abrirModalAutorizacao, setAbrirModalAutorizacao } = useContext(VisitantesContext)
    const [loading, setLoading] = useState(true)
    const [openModalAutorizacao, setOpenModalAutorizacao] = useState(false)
    const [idAutorizacao, setIdAutorizacao] = useState(null)

    useEffect(() => {
        if (autorizados !== null && convites !== null) {
            setLoading(false)
        } else {
            setLoading(true)
        }
    }, [autorizados, convites])

    useEffect(() => {
        if (idAutorizacao) {
            setOpenModalAutorizacao(true)
        }
    }, [idAutorizacao])

    useEffect(() => {
        if (abrirModalAutorizacao) {
            setIdAutorizacao(null)
            setOpenModalAutorizacao(true)
            setAbrirModalAutorizacao(false)
        }
    }, [abrirModalAutorizacao, setAbrirModalAutorizacao])

    return (
        <Grid sx={{
            width: '100%',
            height: '90%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-start',
            alignItems: 'center'
        }}>
            {openModalAutorizacao &&
                <ModalAutorizados
                    openModal={openModalAutorizacao}
                    id={idAutorizacao}
                    setOpenModal={setOpenModalAutorizacao}
                    setIdAutorizacao={setIdAutorizacao}
                    cd_acesso_visitante={visitanteInfo.CD_ACESSO}
                />
            }

            {/* Container scrollável com todas as listas */}
            <Grid sx={{
                width: '100%',
                height: '100%',
                overflow: 'auto',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                padding: '0 10px'
            }}>
                {/* Header das Autorizações */}
                <Grid sx={{
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    padding: '10px'
                    // marginBottom: '10px'
                }}>
                    <OneButton variant="contained" color="one_primary" backgroundColor="#0FBB00"
                        title="Adicionar Autorização"
                        IconStart={AddIcon}
                        newSx={{ fontWeight: 'bold', width: '13%' }} onClick={() => {
                            if (novoVisitante) {
                                setSolicitarSalvarVisitante(true)
                            } else {
                                setIdAutorizacao(null)
                                setOpenModalAutorizacao(true)
                            }
                        }}>Autorização</OneButton>
                    <Typography sx={{ fontSize: '20px', fontWeight: 'bold' }}>Autorizações</Typography>
                    <div style={{ width: '10%' }}></div>
                </Grid>

                {loading || autorizados === null || convites === null
                    ? <CircularProgress />
                    : (
                        <>
                            {/* Seção de Autorizações */}
                            <Grid container gap={1} sx={{
                                width: '100%',
                                alignContent: 'flex-start',
                                justifyContent: 'center',
                                marginBottom: '10px'
                            }}>
                                {autorizados.length > 0
                                    ? autorizados.map((autorizado) => (
                                        <CardAutorizados key={`key-${autorizado.id}`} nome={autorizado.morador}
                                            imovel={autorizado.imovel}
                                            dt_inicial={autorizado.dt_inicial} dt_final={autorizado.dt_final}
                                            id={autorizado.id}
                                            adicionarAutorizacao={() => selecionarAutorizacao(autorizado)}
                                            editarAutorizacao={() => { setIdAutorizacao(autorizado.id) }}
                                            setOpenModalAutorizacao={setOpenModalAutorizacao}
                                        />
                                    ))
                                    : <Typography sx={{ fontSize: '16px', fontWeight: 'bold', marginBottom: '10px' }}>
                                        Nenhuma autorização encontrada para este visitante
                                    </Typography>
                                }
                            </Grid>

                            {/* Seção de Convites */}
                            <Typography sx={{ fontSize: '20px', fontWeight: 'bold', marginBottom: '10px', textAlign: 'center', width: '100%' }}>
                                Convites
                            </Typography>
                            <Grid container gap={1} sx={{
                                width: '100%',
                                alignContent: 'flex-start',
                                justifyContent: 'center',
                                marginBottom: '10px'
                            }}>
                                {convites.length > 0
                                    ? convites.map((convite) => (
                                        <CardAutorizados key={`key-convite-${convite.id}`} nome={convite.nome_morador}
                                            convite={true}
                                            imovel={convite.imovel}
                                            dt_inicial={convite.data_inicial} dt_final={convite.data_final}
                                            id={convite.id}
                                            adicionarAutorizacao={() => selecionarAutorizacao({
                                                id: convite.id,
                                                nome: convite.nome_morador,
                                                imovel: convite.imovel,
                                                dt_inicial: convite.data_inicial,
                                                dt_final: convite.data_final,
                                                CD_ACESSO: convite.CD_ACESSO,
                                                cd_acesso_visitante: convite.cd_acesso_visitante,
                                                notificar_morador: convite.notificar_morador,
                                                unidade1: convite.unidade1,
                                                unidade2: convite.unidade2,
                                                lat: convite.lat,
                                                lng: convite.lng
                                            })}
                                            editarAutorizacao={() => {
                                                // TODO: Implementar edição de convite
                                                console.log('Editar convite:', convite.id)
                                            }} />
                                    ))
                                    : <Typography sx={{ fontSize: '16px', fontWeight: 'bold', marginBottom: '10px' }}>
                                        Nenhum convite encontrado para este visitante
                                    </Typography>
                                }
                            </Grid>
                        </>
                    )}
            </Grid>
        </Grid>
    )
}

export default Autorizados
